<template>
  <div v-if="showToast" class="toast-mensaje bg-secondary">
    Recuperando sesion...
  </div>
  <router-view/>
</template>
<script>
import store from "@/store";
import { ref, onBeforeMount, onBeforeUnmount } from 'vue';
import { useAuth } from './modules/auth/composables/useAuth';
import { useRouter } from "vue-router";
export default {
  setup(props, context) {
    const showToast = ref(false)

    let sessionCheckInterval = null;
    // Antes de montar la aplicación. se busca una sesion de usuario activa
    onBeforeMount(async () => {

      //Añadir un listener para detectar cuando se refresca la pagina
      window.addEventListener('beforeunload', hanleBeforeUnload)

      if((localStorage.getItem("fromPath")).includes("/project/") == false) {
        localStorage.removeItem("refresh")
      }

      if (localStorage.getItem("fromPath") != "/auth") {
        showToast.value = true
      }
      
      const { getUserSessionJWT } = useAuth()
      const router = useRouter()

      const toPath = localStorage.getItem("fromPath")

      // Se comprueba la existencia de un token de sesion y se recupera
      if (localStorage.getItem("session")) {
        console.log("Obteniendo sesion del usuario...")
        try {
          await getUserSessionJWT(localStorage.getItem("session"))

          await store.dispatch("auth/startKeepalive", router)

          // Si hay una sesion activa, se sale del componente de login
          if (localStorage.getItem("session")) {
            if (toPath) {
              router.push( toPath )
            } 
            else {
              router.push("/")
            }
            
          }
        } catch (error) {
          console.error("Error al obtener el usuario: " + error)
        }
      }

      // Se muestra el toast informativo durante al menos 1s
      setTimeout(() => {
        showToast.value = false
      }, 1000)

      sessionCheckInterval = setInterval(async () => {
        const currentSession = localStorage.getItem("session");
        const currentPath = router.currentRoute.value.path;
        const basePath = process.env.NODE_ENV === "production" ? "/" : "/web_calidad/";

        if (!currentSession && currentPath !== "/auth") {
          console.warn("Sesión expirada o inexistente, redirigiendo a /auth...");
          window.location.href = basePath;
        }
        if (currentSession && currentPath === "/auth") {
          window.location.href = basePath
        }
        // Si está en /auth y no hay sesión, no hace nada
      }, 2000);

    })

    const hanleBeforeUnload = () => {
      localStorage.setItem("refresh", "true")
    }

    onBeforeUnmount(() => {
      // Clear the interval when the component is destroyed
      store.dispatch('auth/clearKeepalive');

      if (sessionCheckInterval) {
        clearInterval(sessionCheckInterval);
      }
    });
    return {
      // ...
      showToast
    }
  }
}
</script>

<style>
.toast-mensaje {
  position: fixed;
  top: 20px;
  left: 20px;
  color: #fff;
  padding: 12px 18px;
  border-radius: 6px;
  z-index: 9999;
  box-shadow: 0 2px 6px #66afc2;
  font-size: 14px;
  opacity: 0.95;
}
</style>

